import client, { API_BASE_URL } from './client';

export async function getBannerList() {
  const res = await client.get('/admin/banner');
  return res.data;
}

export async function getBanner(bannerId) {
  const res = await client.get(`/admin/banner/${bannerId}`);
  return res.data;
}

export async function createBanner(payload) {
  const res = await client.post('/admin/banner', payload);
  return res.data;
}

export async function updateBanner(bannerId, payload) {
  const res = await client.put(`/admin/banner/${bannerId}`, payload);
  return res.data;
}

export async function deleteBanner(bannerId) {
  const res = await client.delete(`/admin/banner/${bannerId}`);
  return res.data;
}

/** 드래그앤드롭으로 바뀐 노출순서 저장 */
export async function reorderBanners(orderedBannerIds, updatedBy) {
  const res = await client.put('/admin/banner/reorder', { orderedBannerIds, updatedBy });
  return res.data;
}

// 배너 이미지는 front-web 메인페이지 노출용이라 인증 없이 열람 가능하도록 백엔드에서 열어뒀다.
export function getBannerImageUrl(bannerId) {
  return `${API_BASE_URL}/admin/banner/${bannerId}/image`;
}

export async function uploadBannerImage(bannerId, file, updatedBy) {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('updatedBy', updatedBy);
  const res = await client.post(`/admin/banner/${bannerId}/image`, formData);
  return res.data;
}
